import { defineStore } from 'pinia';

export const useCheckoutQueryStore = defineStore('checkout-query', () => {

  const cartIdFromLink = ref<string | null>(null);

  const setCartIdFromLink = (cartId: string | null) => {

    cartIdFromLink.value = cartId;

  };

  return {
    cartIdFromLink,
    setCartIdFromLink,
  };

});
